
<div style="margin-left: 75px">
    <!-- site dialog -->
    <d-site
        v-if     = "items"
        v-model  = "showSite"
        :site-id = "siteId"
    />
    <!-- site dialog -->

    <d-service-partner
        v-model = "editPartner"
        @stored = "onStored"
    />

    <company-app-bar
        title         = "SERVICE"
        :categories   = "['mnu']"
        @search       = "onSearch"
        @clear-filter = "onClearFilter"
    >
        <template v-slot:toolbar>
            <c-toolbar-button
                icon     = "mdi-plus"
                color    = "primary"
                :size    = "22"
                :tooltip = "$t('msd.service.menu.create.tooltip')"
                class    = "ml-2"
                @click   = "onCreate"
            />
        </template>
    </company-app-bar>

    <div class="v-flex" >
        <c-index
            v-if           = "items"
            :items         = "items"
            :enable-search = "false"
            :criterion     = "criteria"
            :filter-height = "345"
            :filter-on     = "filterOn"
            :filter        = "indexFilter"
            :miminize      = "false"
            children       = "branches"
            @selected      = "onCompany"
            @clear-filter  = "onClearFilter"
            @side          = "onSide"
            ref            = "index"
            style          = "position: relative; margin-right: 75px;"
        >
            <template v-slot:filter>
                <c-service-filter
                    @changed  = "onFilter"
                    @customer = "onCustomer"
                    ref       = "filter"
                />
            </template>

            <template v-slot:item="{ item }">
                <div class="entry">
                    {{ item.name }}
                </div>
                <v-spacer />
                <company-roles
                    :item     = "item"
                    :selected = "selected && selected.id === item.id"
                />
            </template>

            <template v-slot:detail="{ item }">
                <div v-if="item" class="mt-1 h-100" style="width: calc(100% + 12px);">
                    <v-row class="no-frame h-100">
                        <!-- edit company -->
                        <v-col class="no-frame pr-0 h-100" style="width: 33.33%" :class="!item.show ? 'pl-4 pr-2' : 'pl-4 pl-0'">
                            <c-servicepartner-edit
                                v-if     = "selected && selected.id !== unknownCompany.id"
                                :company = "selected"
                                style    = "margin-top: 9px; height: 480px"
                            />

                            <service-customer-list
                                style    = "margin-top: 14px; height: calc(100% - 580px)"
                                v-if     = "selected && !selected.parent"
                                @customer="onCompanyCustomer"
                                ref      = "customerList"
                            />
                        </v-col>

                        <!-- contracts -->
                        <v-col
                            class  = "no-frame pl-2 pr-0"
                            :class = "item.show ? 'pl-4' : 'pl-0'"
                        >
                            <c-contact-card-iterator
                                v-if         = "!contractsVisible"
                                :items       = "contacts.items"
                                :company-id  = "selected ? selected.id : null"
                                :contract-id = "contracts.selected ? contracts.selected.id : null"
                                :customer    = "customer.detail ? customer.detail.id : null"
                                @selected    = "onContactSelected"
                                class        = "w-100"
                            />
                            <c-flip-card
                                v-if   = "contractsVisible"
                                v-model="flip"
                                color="white--text" :top="17" :right="90"
                            >
                                <template v-slot:front>
                                    <c-contract-service-card-iterator
                                        :items       = "contracts.items"
                                        :customer-id = "customer.detail ? customer.detail.id : null"
                                        :contact-id  = "contacts.selected ? contacts.selected.id : null"
                                        :company-id  = "selected ? selected.id : null"
                                        @selected    = "onContractSelected"
                                        @contracts-changed = "onContractsChanged"
                                        @update:items = "contracts.items = $event"
                                        class        = "w-100"
                                        ref          = "contracts"
                                    />
                                </template>
                                <template v-slot:back>
                                    <c-contact-card-iterator
                                        :items       = "contacts.items"
                                        :company-id  = "selected ? selected.id : null"
                                        :contract-id = "contracts.selected ? contracts.selected.id : null"
                                        :customer-id = "customer.detail ? customer.detail.id : null"
                                        :combine-allowed = "true"
                                        @selected    = "onContactSelected"
                                        class        = "w-100"
                                    />
                                </template>
                            </c-flip-card>
                        </v-col>
                        <!-- contracts -->

                        <v-col class="no-frame pl-1">
                            <c-site-card-iterator
                                v-if      = "selected"
                                role      = "MNT"
                                :customer = "customer.detail"
                                :contract = "contracts.selected"
                                :contact  = "contacts.selected"
                                :visible-contracts = "contracts.visible"
                                :contract-height = "contractHeight"
                                class     = "w-100"
                                @site     = "onSite"
                                @click    = "onclick"
                                ref       = "siteIterator"
                            >
                                <template v-slot:editor="{ site }">
                                    <c-contract-mnt-editor
                                        v-if  = "isMaintenance"
                                        :unit = "site"
                                    />
                                    <c-contract-esc-editor
                                        v-if  = "!isMaintenance"
                                        :unit = "site"
                                    />
                                </template>
                            </c-site-card-iterator>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </c-index>
    </div>
</div>
